import delv from 'dlv';

import { UserDetails } from 'state/auth/hooks/use-current-user';

import { QUERY_TYPE } from '../constants';
import { getMeQuery, signInKioskUserMutation } from '../queries/user';

type GetMeResult = {
  me: UserDetails;
};

export const getMe = (numUniquePurchasedItems = 0) => ({
  queryType: QUERY_TYPE.LambdaGraphqlQuery,
  query: getMeQuery,
  variables: {
    numUniquePurchasedItems
  },
  then: (result: GetMeResult): UserDetails | null => delv(result, 'me', null)
});

type SignInArguments = {
  email: string;
  stage: string;
  platform: string;
};

export const kioskSignIn = ({ email, stage, platform }: SignInArguments) => {
  return {
    queryType: QUERY_TYPE.LambdaGraphqlQuery,
    query: signInKioskUserMutation,
    variables: {
      input: {
        email,
        stage,
        platform
      }
    },
    then: (result: any) => delv(result, 'kioskSignIn', null)
  };
};
